<template>
  <div class="wrapper dashboard-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="pc-only main">
          <!-- <h1></h1> -->
          <div class="latest-news" v-if="newsFlag === true">
            <router-link to="/newslist" class="link-over">
              {{ $t("New notification") }}
            </router-link>
          </div>
          <div class="balance">
            <h2>{{ $t("Current staking") }}</h2>
            <div class="total-amount"><span>100</span> USD</div>
            <div class="total-circle">
              <span>{{ $t("AP Reward") }}</span> 100USD
            </div>
            <div class="remail-box">
              {{ $t("Remaining days until staking is lifted") }}<span>365</span>
              {{ $t("days") }}
            </div>
            <ul class="list">
              <li>
                <h3>RP</h3>
                <div class="amount">
                  <span><b>10</b></span>
                </div>
              </li>
              <li>
                <h3>PP</h3>
                <div class="amount">
                  <span><b>10</b></span>
                </div>
              </li>
              <li>
                <h3>CP</h3>
                <div class="amount">
                  <span><b>10</b></span>
                </div>
              </li>
            </ul>
          </div>
          <div class="package">
            <div class="link">
              <span class="img">
                <img src="../assets/img/info-icon-img.svg" alt="" />
              </span>
              <span class="txt link-over" v-on:click="show2">{{
                $t("Click here for an explanation of each point")
              }}</span>
            </div>
            <div class="box-wrap">
              <div class="btn">
                <router-link to="./deposit" class="link-over">{{
                  $t("Charge")
                }}</router-link>
              </div>
              <div class="btn">
                <router-link to="./plan" class="link-over">{{
                  $t("Purchase a plan")
                }}</router-link>
              </div>
              <div class="btn white">
                <router-link to="./restaking" class="link-over"
                  >再ステーキング/出金</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <div class="sp-only">
            <!-- <h1></h1> -->
            <div class="latest-news" v-if="newsFlag === true">
              <router-link to="/newslist" class="link-over">
                {{ $t("New notification") }}
              </router-link>
            </div>
            <div class="balance">
              <h2>{{ $t("Current staking") }}</h2>
              <div class="total-amount"><span>100</span> USD</div>
              <div class="total-circle">
                <span>{{ $t("AP Reward") }}</span> 100USD
              </div>
              <div class="remail-box">
                {{ $t("Remaining days until staking is lifted")
                }}<span>365</span>
                {{ $t("days") }}
              </div>
              <ul class="list">
                <li>
                  <h3>RP</h3>
                  <div class="amount">
                    <span>10</span>
                  </div>
                </li>
                <li>
                  <h3>PP</h3>
                  <div class="amount">
                    <span>10</span>
                  </div>
                </li>
                <li>
                  <h3>CP</h3>
                  <div class="amount">
                    <span>10</span>
                  </div>
                </li>
              </ul>
              <div class="package">
                <div class="link">
                  <span class="img">
                    <img src="../assets/img/info-icon-img.svg" alt="" />
                  </span>
                  <span class="txt link-over" v-on:click="show2">{{
                    $t("Click here for an explanation of each point")
                  }}</span>
                </div>
                <div class="btn">
                  <router-link to="./deposit" class="link-over">{{
                    $t("Charge")
                  }}</router-link>
                </div>
                <div class="btn">
                  <router-link to="./plan" class="link-over">{{
                    $t("Purchase a plan")
                  }}</router-link>
                </div>
                <div class="btn white">
                  <router-link to="./restaking" class="link-over"
                    >再ステーキング/出金</router-link
                  >
              </div>
              </div>
            </div>
          </div>
          <div class="table">
            <h2>
              {{ $t("Purchase history") }}
              <router-link to="./history" class="link-over">{{
                $t("Details")
              }}</router-link>
            </h2>
            <div class="tab-area">
              <div
                class="tab link-over"
                v-on:click="isSelect('1')"
                v-bind:class="{ active: isActive === '1' }"
              >
                BUSINESS
              </div>
              <!-- <div
                class="tab link-over"
                v-on:click="isSelect('2')"
                v-bind:class="{ active: isActive === '2' }"
              >
                INVESTOR
              </div> -->
            </div>
            <div
              class="table-wrap"
              v-show="isActive === '1'"
              v-bind:class="{ active: isActive === '1' }"
            >
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Currency") }}</th>
                  <th>{{ $t("Plan") }}</th>
                  <th>{{ $t("Price") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
              </table>
            </div>
            <div
              class="table-wrap"
              v-show="isActive === '2'"
              v-bind:class="{ active: isActive === '2' }"
            >
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Currency") }}</th>
                  <th>{{ $t("Plan") }}</th>
                  <th>{{ $t("Price") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="table">
            <h2>
              {{ $t("Profit history") }}
              <router-link to="./history" class="link-over">{{
                $t("Details")
              }}</router-link>
            </h2>
            <table>
              <tr>
                <th>{{ $t("Date") }}</th>
                <th>{{ $t("Currency") }}</th>
                <th>{{ $t("Profit") }}</th>
                <th>{{ $t("Type") }}</th>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>USDT</td>
                <td>10</td>
                <td>DIRECT</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>USDT</td>
                <td>10</td>
                <td>DIRECT</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>USDT</td>
                <td>10</td>
                <td>DIRECT</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>USDT</td>
                <td>10</td>
                <td>DIRECT</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <modal
      name="noticeModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box notice-box">
        <div class="text-area">
          <h2>{{ $t("Explanation of each point") }}</h2>
          <p>
            <span>USD</span
            >{{
              $t(
                "These are points that can be used to purchase plans or withdraw funds, and are awarded for deposits made with BTC, ETH, and USDT. Bonuses are also awarded in USD"
              )
            }}
          </p>
          <p><span>AP</span>{{ $t("Number of staking") }}</p>
          <p>
            <span>RP</span
            >{{
              $t(
                "Points where the plan can be increased or transferred to users"
              )
            }}
          </p>
          <p>
            <span>PP</span
            >{{
              $t(
                "Points that exceed the binary bonus limit (only the plan's capital increase is possible)"
              )
            }}
          </p>
          <p>
            <span>CP</span
            >{{
              $t(
                "Points used for capital increase. 20% of the binary bonus will be granted as capital increase points until the principal amount reaches $10,000."
              )
            }}
          </p>
        </div>
        <div class="btn">
          <button v-on:click="hide2" type="button" class="link-over">
            {{ $t("Close") }}
          </button>
        </div>
      </div>
    </modal>

    <Footer title="MY WALLET" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Dashboard",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      changeColor: false,
      amount: "",
      isActive: "1",
      newsFlag: true,
    };
  },

  methods: {
    isSelect: function (num) {
      this.isActive = num;
    },
    show2: function () {
      this.$modal.show("noticeModal");
    },
    hide2: function () {
      this.$modal.hide("noticeModal");
    },
  },

  computed: {
    addClass() {
      if (this.amount !== "") {
        return "done";
      } else {
        return "";
      }
    },
  },
  mounted: function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        var viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }
  },
};
</script>
